<script>
	import {
		bannerList,
		goodsIndex,
		goodsList,
		goodsPai,
		paiTimes
	} from "../api/api";
	import {
		mapGetters
	} from "vuex";
	import router from "../router";

	export default {
		name: "home",
		computed: {
			...mapGetters(['userInfo'])
		},
		data() {
			return {
				bannerListData: [],
				goodsData: [],
				slide: 0,
				slide2: 0,
				sliding: null,
				nowData: [],
				blueData: [],
				recommentData: [],
				title1: '',
				title2: '',
				title3: '',
				banner2: [],
				changciArr: []
			}
		},
		created() {
			// this.getBanner()
			this.getGoodsList()
			this.getChangci()
		},
		mounted() {
			const meta1 = document.createElement('meta');
			meta1.setAttribute('charset', 'utf-8');
			document.head.appendChild(meta1);

			const meta2 = document.createElement('meta');
			meta2.setAttribute('http-equiv', 'X-UA-Compatible');
			meta2.setAttribute('content', 'IE=edge');
			document.head.appendChild(meta2);

			const meta3 = document.createElement('meta');
			meta3.setAttribute('name', 'viewport');
			meta3.setAttribute('content', 'width=device-width, initial-scale=1.0');
			document.head.appendChild(meta3);

			const meta4 = document.createElement('meta');
			meta4.setAttribute('name', 'format-detection');
			meta4.setAttribute('content', 'telephone=no');
			document.head.appendChild(meta4);

			const meta5 = document.createElement('meta');
			meta5.setAttribute('name', 'apple-mobile-web-app-capable');
			meta5.setAttribute('content', 'yes');
			document.head.appendChild(meta5);

			const link1 = document.createElement('link');
			link1.setAttribute('rel', 'stylesheet');
			link1.setAttribute('type', 'text/css');
			link1.setAttribute('href', 'css/vendor.css');
			document.head.appendChild(link1);

			const link2 = document.createElement('link');
			link2.setAttribute('rel', 'stylesheet');
			link2.setAttribute('href', 'css/bootstrap.min.css');
			document.head.appendChild(link2);

			const link3 = document.createElement('link');
			link3.setAttribute('rel', 'stylesheet');
			link3.setAttribute('type', 'text/css');
			link3.setAttribute('href', 'css/main.css');
			document.head.appendChild(link3);

			const link4 = document.createElement('link');
			link4.setAttribute('rel', 'preconnect');
			link4.setAttribute('href', 'https://fonts.googleapis.com');
			document.head.appendChild(link4);

			const link5 = document.createElement('link');
			link5.setAttribute('rel', 'preconnect');
			link5.setAttribute('href', 'https://fonts.gstatic.com');
			document.head.appendChild(link5);

			const link6 = document.createElement('link');
			link6.setAttribute('rel', 'stylesheet');
			link6.setAttribute('href',
				'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
			document.head.appendChild(link6);
		},
		methods: {
			go(name, e) {
				console.log('打印aaaaaaaaaaaaaa')
				router.push({
					name,
					query: {
						id: e.id
					}
				})
			},
			routers(name) {
				console.log('name')
				router.push({
					name
				})
			},
			onSlideStart(slide) {
				this.sliding = true
			},
			onSlideEnd(slide) {
				this.sliding = false
			},
			getBanner() {
				bannerList({}).then(res => {
					console.log(res, '打印res')
					this.bannerListData = res.data.data
				})
			},
			getChangci() {
				paiTimes({

				}).then(res => {
					console.log(res, '打印场次')
					this.changciArr = res.data.data.list.data
				})
			},
			getGoodsList() {
				goodsIndex({}).then(res => {
					console.log(res, '打印res')
					this.bannerListData = res.data.data.banner1
					this.banner2 = res.data.data.banner2.data
					this.nowData = res.data.data.now.data
					this.blueData = res.data.data.blue.data
					this.recommentData = res.data.data.recomment.data
					this.title1 = res.data.data.now.title
					this.title2 = res.data.data.blue.title
					this.title3 = res.data.data.recomment.title
				})
			}
		}
	}
</script>

<template>
	<div>
		<!--    <div id="preloader">-->
		<!--      <div id="loader"></div>-->
		<!--    </div>-->
		<div class="container" style="">
			<b-carousel id="carousel-1" v-model="slide" :interval="5000" controls indicators background="#fff"
				style="text-shadow: 1px 1px 2px #333;height: 542px;overflow: hidden;" @sliding-start="onSlideStart"
				@sliding-end="onSlideEnd">
				<b-carousel-slide v-for="(item,index) in bannerListData" :key="item.id"
					:img-src="item.image"></b-carousel-slide>
			</b-carousel>
		</div>


		<section id="blog-section" class="bg-light padding-large">
			<div class="container">
				<div class="title-wrap d-flex justify-content-between">
					<div class="section-header">
						<h3 class="elementary-title">{{title1}}</h3>
					</div><!--section-header-->
					<div style="cursor: pointer" class="button" @click="routers('contact')">查看更多</div>
				</div>
				<div class="row">
					<div class="post-item col-md-3" style="position:relative;"
						v-for="(item,index) in changciArr.slice(0,7)" :key="item.id" @click="go('changciDetail',item)">
						<div class="status1" v-if="item.status == 1">
							<!-- 预展中 -->
						</div>
						<div class="status1" v-if="item.status == 2">
							<!-- 拍卖中 -->
						</div>
						<div class="status1" v-if="item.status == 3">
							<!-- 竞价中 -->
						</div>
						<div class="status1" v-if="item.status == 4">
							<!-- 已成交 -->
						</div>
						<div class="status1" v-if="item.status == 5">
							
						</div>
						<figure class="zoom-effect">
							<div class="zoom-in"><img style="height: 200px;object-fit: cover;" :src="item.image"
									alt="stories" class="lgpostImg img-fluid"></div>
						</figure>
						<div class="story-title-wrap mt-3">
							<h4 class="story-title">{{item.title}}</h4>
							<div class="post-meta">{{item.describe}}</div>
							<div class="post-meta">拍卖地点：{{item.address}}</div>
							<div class="post-meta">拍卖时间{{item.pai_time}}</div>
						</div>
					</div>
				</div>
			</div>
		</section>

	<!-- 	<section id="latest-posts" class="latest-posts margin-large">
			<div class="container">
				<div class="title-wrap d-flex justify-content-between">
					<div class="section-header">
						<h3 class="elementary-title">{{title2}}</h3>
					</div>
				</div>
				<div style="margin-bottom: 30px">
				</div>
				<div class="row">
					<div class="post-item col-md-4" v-for="(item,index) in blueData.slice(0,5)" :key="item.id">
						<figure class="zoom-effect">
							<div class="zoom-in"><img :src="item.image" style="height: 200px;object-fit: cover"
									alt="stories" class="blogImg img-fluid"></div>
						</figure>
						<div class="story-title-wrap mt-3">
							<h3 class="story-title">{{item.title}}</h3>
							<div class="post-meta">起拍价：{{item.price}}</div>
						</div>
					</div>
				</div>
			</div>
		</section> -->

		<section id="popular-posts" class="popular-posts">
			<div class="container">
				<div class="title-wrap d-flex justify-content-between">
					<div class="section-header">
						<h3 class="elementary-title">{{title3}}</h3>
					</div><!--section-header-->
					<!--          <a href="blog.html" class="button">All news<svg class="bi" width="18" height="18"><use xlink:href="#chevron-forward"></use></svg></a>-->
				</div>
				<div class="row">
					<div class="post-item col-md-4" v-for="(item,index) in recommentData" :key="item.id" @click="go('faxianDetail',item)">
						<figure class="zoom-effect">
							<div class="zoom-in"><img :src="item.image" style="height: 200px;object-fit: cover"
									alt="stories" class="blogImg img-fluid"></div>
						</figure>
						<div class="story-title-wrap mt-3">
							<h3 class="story-title">{{item.title}}</h3>
							<div class="post-meta">精品赏析</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="fuwuBox">
			<img src="../../static/微信图片_20240626143134.jpg" style="width: 100%;height: 380px;" alt="">
			<div class="contentBox">
				<div class="title">
				  <!-- 服务与支持 -->
				</div>
				<div class="moduleBox">
				  <div class="module">
					  <!-- <img src="https://www.cguardian.com/_cg_/home_service_bug.11049cdb.svg" alt="" /> -->
					  <!-- <div class="text">如何参与竞投</div> -->
				  </div><div class="module">
					  <!-- <img src="https://www.cguardian.com/_cg_/home_service_sell.5bdef54a.svg" alt="" /> -->
					  <!-- <div class="text">如何将藏品送拍</div> -->
				  </div><div class="module">
					  <!-- <img src="https://www.cguardian.com/_cg_/home_service_office.7608d072.svg" alt="" /> -->
					  <!-- <div class="text">全球办事处</div> -->
				  </div><div class="module">
					  <!-- <img src="https://www.cguardian.com/_cg_/home_service_business.e3f44f8f.svg" alt="" /> -->
					  <!-- <div class="text">业务范围</div> -->
				  </div>
				</div>
			</div>
		</div>





		<!-- Video Popup -->
		<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
			aria-hidden="true">
			<div class="modal-dialog" role="document">

				<div class="modal-content">

					<div class="modal-body">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><svg
								class="bi" width="40" height="40">
								<use xlink:href="#close-sharp"></use>
							</svg></button>
						<div class="ratio ratio-16x9">
							<iframe class="embed-responsive-item" src="" id="video" allowscriptaccess="always"
								allow="autoplay"></iframe>
						</div>
					</div>

				</div>

			</div>
		</div>
		-
	</div>

</template>

<!--@import 'css/normalize.css';-->
<!--@import 'css/vendor.css';-->
<!--@import 'css/bootstrap.min.css';-->
<style scoped>
	@import 'css/main.css';
	.fuwuBox{
		width: 100%;
		position: relative;
		.contentBox{
			color: #fff;
			width: 60%;
			position:absolute;
			left: 0;
			right: 0;
			top: 60px;
			bottom: 0;
			margin:auto;
			.text{
				margin-top: 20px;
			}
			.title{
				margin-bottom: 90px;
				font-size: 30px;
			}
			.moduleBox{
				display: flex;
				justify-content: space-between;
				
			}
		}
	}
	.status1 {
		position: absolute;
		top: 10px;
		left: 30px;
		color: #fff;
		background-color: #727070;
		font-size: 12px;
		padding: 2px 10px;
		z-index: 99999999;
		border-radius: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/view/home.vue